import axios from 'axios';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';
import IMask from 'imask';

const MODULE = document.querySelectorAll('[data-module="formulario_contato"]');
const FORM_SELECTOR = '.formulario-contato-form';
const RECAPTCHA_ACTION = 'fale_conosco';
const CURRICULO_MAX_SIZE = 2 * 1024 * 1024;
const CURRICULO_EXTENSIONS = ['pdf', 'doc', 'docx'];

class FormularioContato {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        if (!this.components.length) return;

        new Bouncer(FORM_SELECTOR, {
            disableSubmit: true,
            messageAfterField: false,
            messages: {
                missingValue: {
                    default: 'Preenchimento obrigatório.',
                },
                patternMismatch: {
                    email: 'Por favor, insira um e-mail válido.',
                    default: 'Formato inválido.',
                },
            },
            emitEvents: true,
        });

        this.components.forEach((component) => this.initComponent(component));
    }

    initComponent(component) {
        const form = component.querySelector(FORM_SELECTOR);
        if (!form) return;

        const buttonSubmit = form.querySelector('[type="submit"]');
        const fields = form.querySelectorAll('input, textarea, select');

        const assunto = form.querySelector('[data-formulario-contato-assunto]');
        const campoVaga = form.querySelector('[data-formulario-contato-campo-vaga]');
        const campoCurriculo = form.querySelector('[data-formulario-contato-campo-curriculo]');
        const vagaInput = campoVaga ? campoVaga.querySelector('input[name="vaga"]') : null;
        const curriculoInput = form.querySelector('[data-formulario-contato-curriculo-input]');
        const curriculoTrigger = form.querySelector('[data-formulario-contato-curriculo-trigger]');
        const curriculoNome = form.querySelector('[data-formulario-contato-curriculo-nome]');
        const erroGeral = form.querySelector('[data-formulario-contato-erro-geral]');
        const sucesso = form.querySelector('[data-formulario-contato-sucesso]');
        const telefoneInput = form.querySelector('input[name="telefone"]');

        if (telefoneInput) {
            IMask(telefoneInput, { mask: '(00) 00000-0000' });
        }

        const onFirstFocus = () => {
            this.enableSubmitAfterRecaptchaValid(buttonSubmit);
        };

        fields.forEach((field) => {
            field.addEventListener('focus', onFirstFocus, { once: true });
        });

        const toggleTrabalheConosco = (ativo) => {
            [campoVaga, campoCurriculo].forEach((campo) => {
                if (!campo) return;
                campo.classList.toggle('hidden', !ativo);
                campo.classList.toggle('flex', ativo);
            });

            if (vagaInput) {
                vagaInput.disabled = !ativo;
            }

            if (curriculoInput) {
                curriculoInput.disabled = !ativo;
                curriculoInput.toggleAttribute('required', ativo);
            }
        };

        if (assunto) {
            assunto.addEventListener('change', () => {
                const option = assunto.options[assunto.selectedIndex];
                const assuntoSlugInput = form.querySelector('input[name="assunto_slug"]');

                toggleTrabalheConosco(option?.dataset.slug === 'enviar-curriculo');

                if (assuntoSlugInput) {
                    assuntoSlugInput.value = option?.dataset.slug || '';
                }
            });

            const option = assunto.options[assunto.selectedIndex];
            const assuntoSlugInput = form.querySelector('input[name="assunto_slug"]');

            toggleTrabalheConosco(
                option?.dataset.slug === 'enviar-curriculo'
            );

            if (assuntoSlugInput) {
                assuntoSlugInput.value = option?.dataset.slug || '';
            }
        }

        if (curriculoTrigger && curriculoInput) {
            curriculoTrigger.addEventListener('click', () => curriculoInput.click());

            curriculoInput.addEventListener('change', () => {
                const file = curriculoInput.files[0];
                this.setCurriculoError(form, '');

                if (!file) {
                    if (curriculoNome) curriculoNome.textContent = 'Selecione o arquivo';
                    return;
                }

                const extension = file.name.split('.').pop().toLowerCase();
                if (!CURRICULO_EXTENSIONS.includes(extension)) {
                    this.setCurriculoError(form, 'Formato inválido. Envie um arquivo PDF ou DOCX.');
                    curriculoInput.value = '';
                    if (curriculoNome) curriculoNome.textContent = 'Selecione o arquivo';
                    return;
                }

                if (file.size > CURRICULO_MAX_SIZE) {
                    this.setCurriculoError(form, 'Arquivo maior que 2MB.');
                    curriculoInput.value = '';
                    if (curriculoNome) curriculoNome.textContent = 'Selecione o arquivo';
                    return;
                }

                if (curriculoNome) curriculoNome.textContent = file.name;
            });
        }

        this.applyVagaQueryString(assunto, vagaInput, toggleTrabalheConosco);

        form.addEventListener('bouncerFormInvalid', () => {
            if (erroGeral) erroGeral.classList.remove('hidden');
            if (navigator.vibrate) navigator.vibrate([100, 50, 100]);
        });

        form.addEventListener('bouncerFormValid', (event) => this.onFormValid(event, form, erroGeral, sucesso));
    }

    enableSubmitAfterRecaptchaValid(buttonSubmit) {
        if (typeof window.reloadCaptcha !== 'function') {
            return;
        }

        window.reloadCaptcha(RECAPTCHA_ACTION, 'recaptcha_token', (token) => {
            if (!token) return;

            buttonSubmit.removeAttribute('disabled');
        });
    }

    applyVagaQueryString(assunto, vagaInput, toggleTrabalheConosco) {
        const params = new URLSearchParams(window.location.search);
        const vaga = params.get('vaga');
        if (!vaga || !assunto || !vagaInput) return;

        const option = Array.from(assunto.options).find((opt) => opt.dataset.slug === 'enviar-curriculo');
        if (!option) return;

        assunto.value = option.value;
        vagaInput.value = vaga;
        toggleTrabalheConosco(true);

        const assuntoSlugInput = assunto.closest('form')?.querySelector('input[name="assunto_slug"]');

        if (assuntoSlugInput) {
            assuntoSlugInput.value = option.dataset.slug;
        }
    }

    setCurriculoError(form, message) {
        const erro = form.querySelector('#formulario_contato_erro_curriculo');
        if (!erro) return;
        erro.textContent = message;
        erro.className = message ? 'error-message' : '';
    }

    async onFormValid(event, form, erroGeral, sucesso) {
        event.preventDefault();

        const buttonSubmit = form.querySelector('[type="submit"]');
        const recaptchaInput = form.querySelector('input[name="recaptcha_token"]');
        const curriculoNome = form.querySelector('[data-formulario-contato-curriculo-nome]');

        if (erroGeral) erroGeral.classList.add('hidden');
        if (sucesso) sucesso.classList.add('hidden');

        buttonSubmit.setAttribute('disabled', 'disabled');
        buttonSubmit.innerText = i18n.message.formTextLoading;

        const send = async (token) => {
            try {
                if (!token) {
                    throw new Error('Token do reCAPTCHA não foi gerado.');
                }

                if (recaptchaInput) {
                    recaptchaInput.value = token;
                }

                const formData = new FormData(form);
                await axios.post(`${AppSettings.baseApiUrl}basedigital/v1/formulario-contato`, formData);

                form.reset();
                form.querySelector('[data-formulario-contato-assunto]')?.dispatchEvent(new Event('change'));
                if (curriculoNome) curriculoNome.textContent = 'Selecione o arquivo';
                if (sucesso) sucesso.classList.remove('hidden');
            } catch (error) {
                if (erroGeral) erroGeral.classList.remove('hidden');
                console.error(error);
            } finally {
                buttonSubmit.removeAttribute('disabled');
                buttonSubmit.innerText = 'Enviar mensagem';
            }
        };

        if (typeof window.reloadCaptcha !== 'function') {
            console.warn('reloadCaptcha não está disponível. Formulário não enviado.');

            if (erroGeral) erroGeral.classList.remove('hidden');

            buttonSubmit.removeAttribute('disabled');
            buttonSubmit.innerText = 'Enviar mensagem';

            return;
        }

        window.reloadCaptcha(RECAPTCHA_ACTION, 'recaptcha_token', async (token) => {
            await send(token);
        });
    }
}

(() => {
    if (MODULE.length) {
        new FormularioContato();
    }
})();

export default FormularioContato;
